import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BlogPage from "./pages/BlogPage";
import ConnectivityPage from "./pages/ConnectivityPage";
import ContactUsPage from "./pages/ContactUsPage";
import HomePage from "./pages/HomePage";
import UseCasesPage from "./pages/UseCasesPage";
import VerticalSolutionsPage from "./pages/VerticalSolutionsPage";
import FaqPage from "./pages/FaqPage";
import PartnersPage from "./pages/PartnersPage";
import AllBlogs from "./components/AllBlogs";
import SingeVerticalPage from "./components/SingeVerticalPage";
import BlogPageBox2 from "./components/BlogPageBox2";
import BlogPageBox3 from "./components/BlogPageBox3";
import BlogPageBox4 from "./components/BlogPageBox4";
import BlogPageBox5 from "./components/BlogPageBox5";
import BlogPageBox6 from "./components/BlogPageBox6";
import BlogPageBox7 from "./components/BlogPageBox7";
import BlogPageBox8 from "./components/BlogPageBox8";
import BlogPageBox9 from "./components/BlogPageBox9";
import BlogPageBox10 from "./components/BlogPageBox10";
import ConnectivityFrom from "./pages/ConnectivityFrom";
import SingleVerticalMining from "./components/SingleVerticalMining";
import SingleVerticalMedia from "./components/SingleVerticalMedia";
import SingleVerticalConstruction from "./components/SingleVerticalConstruction";
import SingleVerticalLogistics from "./components/SingleVerticalLogistics";
import SingleVerticalAgriculture from "./components/SingleVerticalAgriculture";
import SingleVerticalMaritime from "./components/SingleVerticalMaritime";
import SingleVerticalGasOil from "./components/SingleVerticalGasOil";
import SingleVerticalCrisis from "./components/SingleVerticalCrisis";
import SingleVerticalBasic from "./components/SingleVerticalBasic";
import SingleVerticalElevator from "./components/SingleVerticalElevator";
import SingleVerticalParking from "./components/SingleVerticalParking";
import SingleVerticalPort from "./components/SingleVerticalPort";
import SingleVerticalAirport from "./components/SingleVerticalAirport";
import SingleVerticalEnergy from "./components/SingleVerticalEnergy";
import MarketPlace from "./pages/MarketPlace";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route index path="/" element={<HomePage />} />
        <Route path="vertical-solutions" element={<VerticalSolutionsPage />} />
        <Route path="connectivity" element={<ConnectivityPage />} />
        <Route path="use-cases" element={<UseCasesPage />} />
        <Route path="blog-page" element={<AllBlogs />} />
        <Route path="blog-single" element={<BlogPage />} />
        <Route path="blog-single2" element={<BlogPageBox2 />} />
        <Route path="blog-single3" element={<BlogPageBox3 />} />
        <Route path="blog-single4" element={<BlogPageBox4 />} />
        <Route path="blog-single5" element={<BlogPageBox5 />} />
        <Route path="blog-single6" element={<BlogPageBox6 />} />
        <Route path="blog-single7" element={<BlogPageBox7 />} />
        <Route path="blog-single8" element={<BlogPageBox8 />} />
        <Route path="blog-single9" element={<BlogPageBox9 />} />
        <Route path="blog-single10" element={<BlogPageBox10 />} />

        <Route path="faq" element={<FaqPage />} />
        <Route path="contact-us" element={<ContactUsPage />} />
        <Route path="Partners" element={<PartnersPage />} />
        <Route path="single-vertical" element={<SingeVerticalPage />} />
        <Route
          path="single-vertical-mining"
          element={<SingleVerticalMining />}
        />
        <Route path="single-vertical-media" element={<SingleVerticalMedia />} />
        <Route
          path="single-vertical-construction"
          element={<SingleVerticalConstruction />}
        />
        <Route
          path="single-vertical-logistic"
          element={<SingleVerticalLogistics />}
        />
        <Route
          path="single-vertical-agriculture"
          element={<SingleVerticalAgriculture />}
        />
        <Route
          path="single-vertical-maritime"
          element={<SingleVerticalMaritime />}
        />
        <Route
          path="single-vertical-oil-gas"
          element={<SingleVerticalGasOil />}
        />
        <Route
          path="single-vertical-crisis"
          element={<SingleVerticalCrisis />}
        />
        <Route path="single-vertical-basic" element={<SingleVerticalBasic />} />
        <Route
          path="single-vertical-elevator"
          element={<SingleVerticalElevator />}
        />
        <Route
          path="single-vertical-parking"
          element={<SingleVerticalParking />}
        />
        <Route
          path="single-vertical-airport"
          element={<SingleVerticalAirport />}
        />
        <Route path="single-vertical-port" element={<SingleVerticalPort />} />
        <Route
          path="single-vertical-energy"
          element={<SingleVerticalEnergy />}
        />
        <Route path="marketplace" element={<MarketPlace />} />
        <Route path="connectivity-form" element={<ConnectivityFrom />} />
      </Routes>
    </div>
  );
}

export default App;
